 <!--
  2019-2-14, AJK, created file
  2019-2-20, AJK, updated to check for match between old and new password
  2019-3-06, AJK, updated to use snotify 
 -->


<template>
  <div class="users container">
    <!-- HEADER -->
    <header class="modal-card-head">
      <p class="modal-card-title">{{$props.isUpdate ? 'Update': 'New'}} Address</p>
    </header>
    <!-- NEW ADDRESS COMPONENT -->
    <newAddress v-on:update="update" :isUpdate="$props.isUpdate" :isNew="$props.isNew" :AddressID="$props.AddressID" :Address="$props.Address"></newAddress>

    <!-- FOOTER -->
    <footer class="modal-card-foot">
      <b-button class="button is-primary" type="cancelButton button" outlined @click="closeWindow($parent)">Cancel</b-button>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
import newAddress from '@/components/NewAddress'
import userAPI from '@/api/UserAPI.js'
import sharedAPI from '@/api/SharedAPI.js'
import { mapMutations, mapState, mapGetters  } from 'vuex'
import store from '../store.js'
import axios from "axios";


export default {
  components: {
    'newAddress': newAddress
  },
  name: 'AddressModal',
  props: {
    isNew: Boolean,
    isUpdate: Boolean,
    AddressID: String,
    Address: Object
  },
  data () {
    return {
      shippingAddresses: [],
      shippingAddressLine1: null,
      shippingAddressLine2: null,
      shippingAddressCity: null,
      shippingAddressState: null,
      shippingAddressZip: null,
      shippingAddressCountry: null,
      name: null,
      isLoading: false,
    }
  },
  
  computed: {
  ...mapState([
      'cart', 'userInfo'
    ]),
  },


  mounted() {
  },
  
  methods:{ 
    
    ...mapMutations([
    ]),

    closeWindow: function(parent) {
      parent.close()
    },

    update(address){
      var param = {
        addressID: this.$props.AddressID,
        address: address
      }
      this.$emit('update', param)
      this.closeWindow(this.$parent)
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.cancelButton{
  width: 100%;
}
</style>